import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { usePortalMutation } from 'src/Libs/api'
import { UseMutationResult } from '@tanstack/react-query'
import { resetPassword, ResetPasswordVariables } from '../api/reset-password.api'

const useResetPassword = (): UseMutationResult<void | null, AuthFetchError | Error, ResetPasswordVariables> =>
  usePortalMutation<void, AuthFetchError | Error, ResetPasswordVariables>({
    mutationFn: resetPassword,
  })

export default useResetPassword
